import { IPromoBanner1, TType } from '../repositories/newbuilding-promos/entities/get_promo_banners/PromoBanner1';
import { IV1GetPromoBannersResponse1 } from '../repositories/newbuilding-promos/entities/get_promo_banners/V1GetPromoBannersResponse1';
import { TBanners, TBannerTypes } from '../types/newbuildingBanners/banners';
import { IPromoBanner, TPromoBannerType } from '../types/newbuildingBanners/promoBanner';

const BANNERS_WHITELIST = ['allPromos', 'lastChanceDiscount', 'topPromos', 'newbuildingBroker', 'marketing'];
const BANNERS_WEIGHT: Record<TBannerTypes, number> = {
  lastChanceDiscount: 10,
  topPromos: 10,
  allPromos: 10,
  newbuildingBroker: 120,
  marketing: 160,
};

const getWeightRandomBannerTypes = ({ currentTypes }: { currentTypes: TBannerTypes[] }): TBannerTypes[] => {
  let currentBannerWeights = currentTypes.map(type => ({
    type,
    weight: BANNERS_WEIGHT[type],
  }));

  const bannerTypes: TBannerTypes[] = [];

  while (bannerTypes.length < currentTypes.length) {
    const totalWeights = currentBannerWeights.reduce((accumulator, value) => accumulator + value.weight, 0);
    let random = Math.random() * totalWeights;

    for (let i = 0; i < currentBannerWeights.length; i++) {
      const banner = currentBannerWeights[i];
      if (random < banner.weight) {
        bannerTypes.push(banner.type);
        currentBannerWeights = currentBannerWeights.filter(item => {
          return item.type !== banner.type;
        });
      }
      random = random - banner.weight;
    }
  }

  return bannerTypes;
};

function assertBannerType(bannerType: TType): asserts bannerType is TPromoBannerType {
  if (!BANNERS_WHITELIST.includes(bannerType)) {
    throw new Error(`Unknown banner type: ${bannerType}`);
  }
}

export const prepareBanner = (banner: IPromoBanner1): IPromoBanner | null => {
  try {
    const bannerType: IPromoBanner1['type'] = banner.type;
    assertBannerType(bannerType);

    return {
      action: {
        link: banner.action.link,
        title: banner.action.title,
      },
      imageUrl: banner.imageUrl,
      subtitle: banner.subtitle,
      title: banner.title,
      type: bannerType,
    };
  } catch (error) {
    return null;
  }
};

//Возвращает массив баннеров в порядке их ранжирования по весам
export const prepareBanners = (banners: IV1GetPromoBannersResponse1): TBanners[] => {
  const currentTypes = [] as TBannerTypes[];
  const mappedBanners = {} as Record<TBannerTypes, TBanners>;
  const allPromos = prepareBanner(banners.allPromos);
  const newbuildingBroker = banners.newbuildingBroker ? prepareBanner(banners.newbuildingBroker) : null;
  const marketing = banners.marketingBanner ? prepareBanner(banners.marketingBanner) : null;

  /* istanbul ignore else */
  if (allPromos) {
    currentTypes.push(allPromos.type);
    mappedBanners[allPromos.type] = allPromos;
  }

  if (newbuildingBroker) {
    currentTypes.push(newbuildingBroker.type);
    mappedBanners[newbuildingBroker.type] = newbuildingBroker;
  }

  if (marketing) {
    currentTypes.push(marketing.type);
    mappedBanners[marketing.type] = marketing;
  }

  /* istanbul ignore else */
  if (banners.compilations) {
    banners.compilations.forEach(compilation => {
      currentTypes.push(compilation.type);
      mappedBanners[compilation.type] = compilation;
    });
  }

  const order: TBannerTypes[] = getWeightRandomBannerTypes({ currentTypes });

  return order.map((item: TBannerTypes) => mappedBanners[item]);
};
